import http from 'services/http-service';

const VoucherService = {
    Create(name: string, voucherCode: string, isPercentage: boolean, value: number, isCanExpire: boolean, expiryDate: Date, time: string, isForAllProgram: boolean, programId: string, isHaveRestriction: boolean, restrictionProgramId: string, isActive: boolean) {
        var hour = parseInt(time.split(":")[0]);
        var minute = parseInt(time.split(":")[1]);
        var second = 59;
        var expiryDateToEndDay = isCanExpire ? new Date(expiryDate.getFullYear(), expiryDate.getMonth(), expiryDate.getDate(), hour, minute, second) : null;
        let response = http.post('/vouchers', { name, voucherCode, isPercentage, value, isCanExpire, expiryDate: expiryDateToEndDay, isForAllProgram, programId, isHaveRestriction, restrictionProgramId, isActive });
        return response;
    },

    Update(id: any, name: string, voucherCode: string, isPercentage: boolean, value: number, isCanExpire: boolean, expiryDate: Date, time: string, isForAllProgram: boolean, programId: string, isHaveRestriction: boolean, restrictionProgramId: string, isActive: boolean) {
        var hour = parseInt(time.split(":")[0]);
        var minute = parseInt(time.split(":")[1]);
        var second = 59;
        var expiryDateToEndDay = isCanExpire ? new Date(expiryDate.getFullYear(), expiryDate.getMonth(), expiryDate.getDate(), hour, minute, second) : null;
        let response = http.put('/vouchers', { id, name, voucherCode, isPercentage, value, isCanExpire, expiryDate: expiryDateToEndDay, isForAllProgram, programId, isHaveRestriction, restrictionProgramId, isActive });
        return response;
    },

    Delete(id: any) {
        let response = http.delete(`/vouchers/${id}`);
        return response;
    },

    Activate(id: string) {
        let response = http.put("/vouchers/" + id + "/Activate");
        return response;
    },

    DeActivate(id: string) {
        let response = http.put("/vouchers/" + id + "/DeActivate");
        return response;
    },

    GetListVoucher(searchKey: string, skipCount: number, maxResultCount: number) {
        let response = http.get('/vouchers', { params: { searchKey: searchKey, skipCount: skipCount, maxResultCount: maxResultCount } });
        return response;
    },

    Get(id: any) {
        let response = http.get(`/vouchers/${id}`);
        return response;
    }
};

export default VoucherService;